
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Notificacion } from '@/components/a-interfaz/a-notificaciones/a-notificaciones';
    import router from '@/__env/router.index';


    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class NotificacionTexto extends Vue
    {
        @Prop() public Notificacion: Notificacion;
        public Eliminar()
        {

            this.Notificacion.Eliminar();
        }

        public Abrir()
        {
            if ( this.Notificacion.Redirecciona )
            {
                router.push( this.Notificacion.Redirecciona );
                this.Eliminar();
            }
        }
    }
